import Vue from 'vue'
import { login, smslogin, getInfo } from '@/api/login'
import { Clogin,LogoutC } from '@/api/loginCai'
import { ACCESS_TOKEN, ACCESSCAI_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
const user = {
  state: {
    token: '',
    rookie_token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_CTOKEN: (state, token) => {
      state.RookieToken = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          if (response.code === 1) {
            const result = response.data
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            resolve()
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    RookieLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        Clogin(userInfo).then(response => {
          if (response.code === 1) {
            const result = response.data
            Vue.ls.set(ACCESSCAI_TOKEN, result['rookie-token'], 7 * 24 * 60 * 60 * 1000)
            console.log(result)
            commit('SET_CTOKEN', result.token)
            resolve()
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 短信登录
    SmsLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        smslogin(userInfo).then(response => {
          if (response.code === 1) {
            const result = response.data
            Vue.ls.set(ACCESS_TOKEN, result.token, 7 * 24 * 60 * 60 * 1000)
            Vue.ls.set(ACCESSCAI_TOKEN, result.RookieToken, 7 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', result.token)
            commit('SET_TOKEN', result.RookieToken)
            resolve()
          } else {
            reject(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const result = response.data
          if (result.role && result.role.permissions.length > 0) {
            const role = result.role
            role.permissions = result.role.permissions
            role.permissions.map(per => {
              if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
                const action = per.actionEntitySet.map(action => { return action.action })
                per.actionList = action
              }
            })
            role.permissionList = role.permissions.map(permission => { return permission.permissionId })
            commit('SET_ROLES', result.role)
            commit('SET_INFO', result)
          } else {
            reject(new Error('getInfo: roles must be a non-null array !'))
          }
          commit('SET_NAME', { name: result.user.username, welcome: welcome() })
          commit('SET_AVATAR', result.avatar)

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        Vue.ls.remove(ACCESS_TOKEN)
        resolve()
        // logout(state.token).then(() => {
        //   resolve()
        // }).catch(() => {
        //   resolve()
        // })
      })
    },
    // 菜鸟登出
    LogoutCai({ commit, state }) {
      return new Promise((resolve, reject) => {
        LogoutC(state.RookieToken).then(response => {
          commit('SET_CTOKEN', '')
          commit('SET_ROLES', [])
          Vue.ls.remove(ACCESSCAI_TOKEN)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
